import React, { Component } from 'react';
import DecisioningServiceClient from './decisioningServiceClient';
export class CognitoAuth extends Component {
  render() {
    let client = new DecisioningServiceClient();
    client.getEntry();

    return <div className={'qa-cognito-auth'}></div>;
  }
}
